var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","text":"","color":_vm.btnColor},on:{"click":function($event){return _vm.$emit('changePaidStatus', _vm.idProforma)}}},[_c('paid-icon',{attrs:{"color":_vm.btnColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }